import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

const BarraProgresoCircular = ({ porcentaje = '0%', color }) => {

  const [porcentajeLocal, setPorcentajeLocal] = useState(porcentaje.replace(',', '.').replace('%', ''))
  const [valorPorcentaje, setValorPorcentaje] = useState(0)

  useEffect(() => {
    setPorcentajeLocal(porcentaje.replace(',', '.').replace('%', ''))
    setValorPorcentaje(0)
  }, [porcentaje])

  useEffect(() => {
    if (valorPorcentaje < porcentajeLocal) {
      setTimeout(() => {
        setValorPorcentaje(valorPorcentaje + 9 < porcentajeLocal ? valorPorcentaje + 9 : porcentajeLocal)
      }, 100);
    }

  }, [porcentajeLocal, valorPorcentaje])



  return (
    <GraficoDonut porcentaje={valorPorcentaje + '%'} color={color}>
      <div id="grad1">
        <Porcentaje>{porcentaje.replace('.', ',')}</Porcentaje>
      </div>
    </GraficoDonut>
  );
};

const Porcentaje = styled.span`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
`
const GraficoDonut = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  border-radius:50%;
  background: radial-gradient(
    circle closest-side,
      transparent 80%,
      transparent 0
    ),
    conic-gradient(
      ${({ color }) => color} 0,
      ${({ color }) => color} ${({ porcentaje }) => porcentaje},
      #C4C4C4 0,
      #C4C4C4 100%
    );
  

  #grad1::before {
    height: 50%;
    width: 50%;
    background:white;
    border-radius:50%;
    border: 5px solid rgba(0, 0, 0, .1);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #grad1 span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;
export default BarraProgresoCircular;